export default __webpack_public_path__ + "static/media/1444.01f25e15.png";